import { render, staticRenderFns } from "./StyleTemplateMetadata.vue?vue&type=template&id=7450068a&scoped=true"
import script from "./StyleTemplateMetadata.vue?vue&type=script&lang=js"
export * from "./StyleTemplateMetadata.vue?vue&type=script&lang=js"
import style0 from "./StyleTemplateMetadata.vue?vue&type=style&index=0&id=7450068a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7450068a",
  null
  
)

export default component.exports